import { Component, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ApplicationContextBoundComponent } from 'src/app/shared/components/application-context-bound.component';
import { FeesSection, CorrespondentOnlySection, DynamicFee } from 'src/app/cd-request/models/closing-disclosure-doc-request.model';

export interface ServicesCanShopFormData {
  surveyFee: number;
  dynamicFees: DynamicFee[];
}

@Component({
  selector: 'services-can-shop',
  templateUrl: './services-can-shop.component.html',
  styleUrls: ['./services-can-shop.component.scss'],
  standalone: false
})
export class ServicesCanShopComponent extends ApplicationContextBoundComponent implements OnInit, OnChanges {

  @ViewChild('servicesCanShopForm') servicesCanShopForm: NgForm;

  @Input() fees: FeesSection | undefined;
  @Input() correspondentOnly: CorrespondentOnlySection | undefined;

  formData: ServicesCanShopFormData = {
    surveyFee: null,
    dynamicFees: []
  };

  constructor(
    protected readonly injector: Injector
  ) {
    super(injector);
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fees'] || changes['correspondentOnly']) {
      this.populateFormFromApiData();
    }
  }

  validateForm(): boolean {
    if (this.servicesCanShopForm) {
      this.servicesCanShopForm.form.markAllAsTouched();
      return this.servicesCanShopForm.form.valid;
    }
    return true;
  }

  getFormData(): ServicesCanShopFormData {
    return {
      ...this.formData,
      dynamicFees: [...this.formData.dynamicFees]
    };
  }

  addDynamicFee(): void {
    this.formData.dynamicFees.push({ uuid: crypto.randomUUID(), name: '', amount: null });
  }

  removeDynamicFee(index: number): void {
    this.formData.dynamicFees.splice(index, 1);
  }

  private populateFormFromApiData(): void {
    if (this.fees) {
      this.formData.surveyFee = this.fees.surveyFee || null;
      this.formData.dynamicFees = this.fees.dynamicServicesCanShop?.map(fee => ({
        ...fee,
        uuid: fee.uuid || crypto.randomUUID()
      })) || [];
    }
  }
}
